'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { withRouter } from 'react-router-dom'; // Throw out all but router to avoid re-renders

export const withRouterLite = WrappedComponent => withRouter( // eslint-disable-next-line no-unused-vars
(_ref) => {
  let {
    history
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["location", "params", "search", "router", "history"]);

  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
    history: history
  }, props));
});